import { Skeleton, Space } from 'antd';

/** A vertical stack of list-row skeletons — table/list loading placeholder. */
export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} active title={false} paragraph={{ rows: 1 }} />
      ))}
    </Space>
  );
}

/** A grid of card-shaped skeletons — product/board card loading placeholder. */
export function CardGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div
      style={{
        display: 'grid',
        gap: 16,
        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
      }}
    >
      {Array.from({ length: count }, (_, i) => (
        <Skeleton.Image key={i} active style={{ width: '100%', height: 160 }} />
      ))}
    </div>
  );
}

/** A single-block skeleton for a page/section still loading. */
export function BlockSkeleton() {
  return <Skeleton active paragraph={{ rows: 4 }} />;
}
